import _getWordCount from "../quill/getWordCount.js";
const getWordCount = _getWordCount;
export default (function getAvgTimePerWord(event) {
  let duration = event.end - event.start;
  let wordCount = getWordCount(event.text);
  return duration / wordCount;
});